import { render, staticRenderFns } from "./EcFanDataModule.vue?vue&type=template&id=893e138e&scoped=true"
import script from "./EcFanDataModule.vue?vue&type=script&lang=js"
export * from "./EcFanDataModule.vue?vue&type=script&lang=js"
import style0 from "./EcFanDataModule.vue?vue&type=style&index=0&id=893e138e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893e138e",
  null
  
)

export default component.exports